import { useTranslation } from 'react-i18next';

import step1Image from './images/step1.png';
import step2Image from './images/step2.png';
import step3Image from './images/step3.png';
import Image from 'next/image';

type StepProps = {
  stepNumber: number;
  description: string;
  image: {
    width: number;
    height: number;
    src: string;
  };
};

const Step = ({ stepNumber, description, image }: StepProps) => {
  const { t } = useTranslation();
  return (
    <div className="border border-neutral-light rounded-lg p-[8px] flex justify-between">
      <div className="p-[12px]">
        <div className="text-primary-mid uppercase tracking-[2px] text-[12px] leading-[16px] font-medium ">
          {t('components.InstagramShareAbTest.StepNumber', { stepNumber })}
        </div>
        <div className="text-[16px] font-[400] leading-[24px]">{description}</div>
      </div>
      <Image
        src={image.src}
        alt={`Step ${stepNumber}`}
        height={image.height}
        width={image.width}
        className="mt-[8px] h-[96px] rounded-lg"
      />
    </div>
  );
};

export const ShareInstagramAbTest = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-[16px] flex flex-col gap-[8px] mb-[16px]">
      <Step
        stepNumber={1}
        description={t('components.InstagramShareAbTest.Step1')}
        image={{ src: step1Image.src, width: 96, height: 96 }}
      />
      <Step
        stepNumber={2}
        description={t('components.InstagramShareAbTest.Step2')}
        image={{ src: step2Image.src, width: 109.54, height: 96 }}
      />
      <Step
        stepNumber={3}
        description={t('components.InstagramShareAbTest.Step3')}
        image={{ src: step3Image.src, width: 96, height: 96 }}
      />
    </div>
  );
};
